module.exports = __webpack_public_path__ + "img/service_img7.5d6f5f5c.png";